import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-emojis',
  templateUrl: './emojis.component.html',
  styleUrls: ['./emojis.component.scss']
})
export class EmojisComponent implements OnInit {@Input()
    @Input()
  primarycolor: string;

  @Input()
  secondarycolor: string;

  @Input()
  emojis;

  constructor() {
  }

    ngOnInit() {
  }

}
